import { jsx as _jsx } from "react/jsx-runtime";
import angleDownIcon from '@/core/svg/tailwind/angle-down.svg';
import { IconButton } from '@/core/ui/IconButton';
import { SvgIcon } from '@/core/ui/SvgIcon';
const DateRangePickerChevron = () => {
    return (_jsx(IconButton, { size: "small", children: _jsx(SvgIcon, { icon: angleDownIcon, size: "xl" }) }));
};
export { DateRangePickerChevron };
